import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { CustomScriptLoader } from './custom-script-loader.service';

@Injectable({ providedIn: 'root' })
export class AdyenScriptService {
  private readonly customScriptLoader = inject(CustomScriptLoader);
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);

  loadAdyen(env: string, version: string): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const cssId = `adyen-css-${version}`;
      if (!this.document.getElementById(cssId)) {
        const cssLink = this.document.createElement('link');
        cssLink.id = cssId;
        cssLink.rel = 'stylesheet';
        cssLink.crossOrigin = 'anonymous';
        cssLink.href = `https://checkoutshopper-${env}.adyen.com/checkoutshopper/sdk/${version}/adyen.css`;
        this.document.head.appendChild(cssLink);
      }

      const scriptSrc = `https://checkoutshopper-${env}.adyen.com/checkoutshopper/sdk/${version}/adyen.js`;

      if (this.customScriptLoader.hasScript(scriptSrc)) {
        resolve();
        return;
      }

      this.customScriptLoader.embedScript({
        src: scriptSrc,
        attributes: { crossorigin: 'anonymous', id: `adyen-js-${version}` },
        callback: () => resolve(),
        errorCallback: (error) => console.error('error loading adyen script ', error),
        asyncLoad: false
      } as any);
    });
  }
}
